module.exports = __webpack_public_path__ + "img/bg-ppt-2.f0e0448b.png";